import {view} from '@sail/ui';
import {FormattedMessage, useIntl, defineMessages} from 'react-intl';
import {useTheme} from '../../ThemeProvider';

const messages = defineMessages({
  defaultTitleMsg: {
    id: 'conversations_ui.support_conversations_client.support_conversations.client.dot_com.header.title.label',
    description: 'The title of the chat header',
    defaultMessage: 'Ask a question',
  },
  csatTitleMsg: {
    id: 'conversations_ui.support_conversations_client.support_conversations.client.dot_com.header.titleForCSAT.label',
    description: 'The title of the chat header for CSAT screen',
    defaultMessage: 'Share feedback',
  },
});

type Props = {
  isCSAT: boolean;
};

export function DotComHeaderTitle({isCSAT}: Props) {
  const intl = useIntl();
  const theme = useTheme();

  const message = isCSAT ? messages.csatTitleMsg : messages.defaultTitleMsg;

  const formattedTitle = <FormattedMessage {...message} />;

  return (
    <view.h3
      data-testid="conversations-widget-header-title"
      css={{
        font: 'label.large.emphasized',
        color: theme.onBrandTextColor,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }}
      aria-label={intl.formatMessage(message)}
    >
      {formattedTitle}
    </view.h3>
  );
}
